import { useTranslation } from 'react-i18next'
import { LocalizedTranslationJobSection } from '@/features/localized-translation'
import { TRANSLATION_JOB_SCOPE } from '@/shared/constants/status'
import { ReasonType } from '@/shared/constants/translation-status'

export interface TenantWelcomeTranslation {
  language: string
  name: string
  description: string
}

interface TenantTranslationSectionProps {
  languages: string[]
  translations: TenantWelcomeTranslation[]
  onChange: (translations: TenantWelcomeTranslation[]) => void
  onGenerationStateChange?: (hasPendingGeneration: boolean) => void
  entityId: string
  entityLabel?: string
  entityPath?: string
}

export function TenantTranslationSection({
  languages,
  translations,
  onChange,
  onGenerationStateChange,
  entityId,
  entityLabel,
  entityPath,
}: TenantTranslationSectionProps) {
  const { t } = useTranslation()

  return (
    <LocalizedTranslationJobSection<TenantWelcomeTranslation>
      languages={languages}
      translations={translations}
      onChange={onChange}
      scope={TRANSLATION_JOB_SCOPE.TENANT}
      entityId={entityId}
      {...(entityLabel ? { entityLabel } : {})}
      {...(entityPath ? { entityPath } : {})}
      audioEnabled={ReasonType.TRANSLATE_AUDIO_NOT_AVAILABLE}
      requiredMessage={t('tenant.translationRequired', {
        defaultValue: 'Vui lòng nhập đầy đủ tiêu đề và mô tả trước khi dịch.',
      })}
      {...(onGenerationStateChange ? { onGenerationStateChange } : {})}
      fields={() => [
        {
          key: 'name',
          label: t('tenant.welcomeTitle', { defaultValue: 'Welcome title' }),
          placeholder: t('tenant.welcomeTitlePlaceholder', {
            defaultValue: 'Enter welcome title',
          }),
        },
        {
          key: 'description',
          label: t('tenant.welcomeDescription', { defaultValue: 'Welcome description' }),
          placeholder: t('tenant.welcomeDescriptionPlaceholder', {
            defaultValue: 'Enter welcome description',
          }),
          multiline: true,
          rows: 3,
        },
      ]}
      blockTitle={t('tenant.welcomeContent', { defaultValue: 'Welcome Content' })}
      translateLabel={t('poi.localizedSpeech.generateSelectedTextOnly')}
      scopeHint={t('poi.localizedSpeech.scopeHint')}
      loadingText={t('poi.localizedSpeech.generatingTextOnly')}
    />
  )
}
